import axios from "axios";
import React, { use, useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useParams } from "react-router-dom";
import InvoiceStatusCell from "../client/InvoiceStatusCell";
import { openInAppTab } from "../../utils/tabNavigation";
import useSmartBack from "../../hooks/useSmartBack";

function GridViewUser() {
  const user = JSON.parse(localStorage.getItem("user"));
  const { id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [options, setoptions] = useState([]);
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const [data, setdata] = useState([]);

  const handleBack = useSmartBack(id ? "/role/grid_view" : "/role/list");

  useEffect(() => {
    async function fetchOptions() {
      setGlobalLoading(true); //  Show loader before API call
      try {
        const response = await axios.get(
          `${API_BASE_URL}/roles/get_my_roles/${`${id ?? user.id}`}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setoptions(response.data || []);
        setOptionsLoaded(true);
      } catch (error) {
        console.error("API Error:", error);
        setoptions([]); // Prevent errors from breaking UI
        setOptionsLoaded(true);
      } finally {
        setOptionsLoaded(true);
        setGlobalLoading(false);
      }
    }
    fetchOptions();
  }, []);

  useEffect(() => {
    if (options.length > 0 || optionsLoaded) {
      setGlobalLoading(false);
      setdata(options.backup_items_list);
      console.log(options.backup_items_list);
    }
  }, [options]);

  function decodeHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }
  function toTitleCase(str) {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }

  function formatTimestamp(ts) {
    const date = new Date(ts * 1000); // convert seconds → ms
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  }

  const getTATDays = (datetime) => {
    if (!datetime) return "-";

    // handle seconds vs ms
    const createdAt =
      String(datetime).length === 10 ? datetime * 1000 : datetime;
    const diffMs = Date.now() - createdAt;

    if (diffMs < 0) return "0d";

    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    return `${days} days`;
  };

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Roles</h2>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
            <div className="me-2 mb-2">
              <div className="d-flex align-items-center border bg-warning rounded p-1 me-2 icon-list">
                <a
                  href="javascript:void(0);"
                  onClick={handleBack}
                  className="btn btn-icon btn-sm me-1"
                  title="Old View"
                >
                  <i className="ti ti-list-tree"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {data &&
            data.length > 0 &&
            data.map((item, index) => (
              <div className="col-xxl-6 col-xl-6 col-md-12">
                <div
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    openInAppTab(
                      `/role/view/${item.role_id}`,
                    )
                  }
                >
                  <div className="my-d-flex card-body">
                    <div className="col-xxl-8 col-xl-8 col-md-12">
                      <div className="d-flex align-items-start mb-3">
                        <a
                          href="javascript:void(0)"
                          className="avatar avatar-lg avatar rounded-circle me-2"
                          style={{
                            flex: "none",
                            display: "grid",
                            alignContent: "center",
                          }}
                        >
                          <img
                            src={`${PINE_BASE_URL}/files/companyLogo/${
                              item?.logo ?? "nologo.png"
                            }`}
                            className="img-fluid h-auto w-auto mb-1"
                            alt="img"
                          />
                          <span className="fs-10 fw-medium badge bg-warning">
                            {item.role_id}
                          </span>
                        </a>
                        <div className="d-flex align-items-center flex-shrink-0">
                          <div className="d-flex flex-column">
                            <div className="d-flex flex-wrap mb-1">
                              <h6 className="fs-14 fw-semibold me-1">
                                <a
                                  href="javascript:void(0)"
                                  title={item.role_name}
                                >
                                  {toTitleCase(decodeHtml(item.role_name))
                                    .length > 40
                                    ? toTitleCase(
                                        decodeHtml(item.role_name)
                                      ).slice(0, 40) + "..."
                                    : toTitleCase(decodeHtml(item.role_name))}
                                </a>
                              </h6>
                            </div>
                            <p className="text-gray fs-13 fw-normal">
                              {item.company_name.length > 45
                                ? item.company_name.slice(0, 45) + "..."
                                : item.company_name}
                            </p>
                            <div
                              style={{ display: "flex", marginLeft: "-55px" }}
                            >
                              <div className="bg-gray-100 p-1 rounded d-flex align-items-center me-2">
                                <a
                                  href="javascript:void(0)"
                                  className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                                >
                                  <img
                                    src={`${PINE_BASE_URL}/files/media/${item.role_managerPic}`}
                                    alt="Img"
                                  />
                                </a>
                                <h6 className="fs-12">
                                  <a href="javascript:void(0)">
                                    {item.role_manager}
                                  </a>
                                </h6>
                              </div>
                              <div className="bg-gray-100 p-1 rounded d-flex align-items-center me-2">
                                <a
                                  href="javascript:void(0)"
                                  className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                                >
                                  <img
                                    src={`${PINE_BASE_URL}/files/media/${item.assignedToPic}`}
                                    alt="Img"
                                  />
                                </a>
                                <h6 className="fs-12">
                                  <a href="javascript:void(0)">
                                    {item.assignedTo}
                                  </a>
                                </h6>
                              </div>
                            </div>
                            {item.allocations.length > 0 && (
                              <div
                                className="d-flex align-items-center justify-content-between pt-1"
                                style={{ marginLeft: "-60px" }}
                              >
                                <div className="avatar-list-stacked avatar-group-sm">
                                  {item.allocations.map((allocation, index) => (
                                    <span
                                      key={index}
                                      className="avatar avatar-rounded ms-2"
                                      title={allocation.allocated}
                                    >
                                      <img
                                        src={`${PINE_BASE_URL}/files/media/${allocation.userpic}`}
                                        className="border border-white"
                                        alt="img"
                                      />
                                    </span>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-md-12">
                      <div className="ps-sm-2">
                        <div className="bg-white rounded mb-2">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <span className="bg-soft-primary p-1 d-flex rounded-circle me-2">
                                <span className="bg-warning rounded-circle d-block p-1"></span>
                              </span>
                              <h5 className="me-2 fs-10">Profile Added</h5>
                              <span className="badge bg-light rounded-pill">
                                {item.profile_added}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="bg-white rounded mb-2">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <span className="bg-soft-primary p-1 d-flex rounded-circle me-2">
                                <span className="bg-warning rounded-circle d-block p-1"></span>
                              </span>
                              <h5 className="me-2 fs-10">Recomended</h5>
                              <span className="badge bg-light rounded-pill">
                                {item.recommended}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="bg-white rounded mb-2">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <span className="bg-soft-primary p-1 d-flex rounded-circle me-2">
                                <span className="bg-warning rounded-circle d-block p-1"></span>
                              </span>
                              <h5 className="me-2 fs-10">Raised</h5>
                              <span className="badge bg-light rounded-pill">
                                <InvoiceStatusCell role_id={item.role_id} />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-12 col-xl-12 col-md-12 mb-0 table-group-divider">
                      <div className="d-flex align-items-start mt-1">
                        <div className="bg-gray-100 p-1 rounded d-flex align-items-center me-2">
                          <i className="fa-solid fa-calendar me-1"></i>
                          <h6 className="fs-12">
                            <a href="javascript:void(0)">
                              {formatTimestamp(item.datetime)}
                            </a>
                          </h6>
                        </div>
                        <div className="bg-gray-100 p-1 rounded d-flex align-items-center me-2">
                          <i className="fa-solid fa-clock me-1"></i>
                          <h6 className="fs-12">
                            <a href="javascript:void(0)">
                              {getTATDays(item.datetime)}
                            </a>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}

export default GridViewUser;
